/** Ruta `/auditoria` (T079): consulta de auditoría de la empresa de la sesión. */
import { createFileRoute } from '@tanstack/react-router';

import { AuditPage } from '../../features/audit/audit-page';

export const Route = createFileRoute('/_app/auditoria')({
  component: AuditPage,
});
